const NB_OF_STEPS = 8;

export default NB_OF_STEPS;
